import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../Translations';
import { ConnectionSummary } from '../../Types';
import ConnectionRow from './ConnectionRow';

interface Props {
  connections: ReadonlyArray<ConnectionSummary>;
}

const ConnectionList: React.FC<Props> = ({ connections }) => (
  <div>
    <h3 className="text-base font-semibold text-foreground">
      <T kind="Identity providers" />
    </h3>
    <div className="mt-3 rounded-lg border border-border bg-card px-6 py-2">
      {connections.map((connection) => (
        <ConnectionRow key={connection.id} connection={connection} />
      ))}
    </div>
  </div>
);

export default observer(ConnectionList);
